import { ClockOutlineIcon } from "@images/svgIcons/clockOutlineIcon"
import { InfinityIcon } from "@images/svgIcons/infinityIcon"
import { OnOffIcon } from "@images/svgIcons/onOffIcon"
import { word } from "@modules/core/utils/i18n"
import { useProgramSidebar } from "@modules/programs/hooks/useProgramSidebar"
import { ProgramInfiniteTypeOf } from "@modules/programs/programInfiniteTypes"
import { ItemProgram, SharedCoachStatus, UserProgramItem } from "@modules/programs/programTypes"
import { HUText } from "@modules/ui/components/huText"
import { useMemo } from "react"
import styled, { useTheme } from "styled-components"

type HuProgramMiniCardsProps = {
  item: ItemProgram | UserProgramItem
  disabled?: boolean
  minWidth?: string
  editionAllowed?: boolean
} & React.HTMLAttributes<HTMLDivElement>

export const HuProgramMiniCards: React.FC<HuProgramMiniCardsProps> = ({
  item,
  disabled = false,
  className = "w-12rem h-10rem mx-1",
  minWidth = "12rem",
  editionAllowed = false,
  ...props
}) => {
  const theme = useTheme()
  const { navigateToProgramView } = useProgramSidebar()

  const itemIcon = useMemo(() => {
    if (item._programType === ProgramInfiniteTypeOf) {
      return <InfinityIcon color={theme.mainWhite} width={15} height={15} />
    } else return <OnOffIcon color={theme.mainWhite} width={15} height={15} />
  }, [item])

  const onViewDetailsClick = () => {
    if (!disabled) {
      navigateToProgramView(item.id, item._programType, editionAllowed, {
        leftButtonColor: theme.mainWhite,
        replaceAllComponents: false,
      })
    }
  }

  return (
    <div
      onClick={onViewDetailsClick}
      style={{
        background: ` linear-gradient(180deg, rgba(34, 34, 34, 0) 33%, rgba(34, 34, 34, 1) 100%) , url(${item.image?.path})`,
        minWidth: minWidth ? minWidth : "",
      }}
      className={
        "flex flex-column justify-content-between  border-round-3xl bg-cover bg-center relative overflow-hidden " +
        (disabled ? " " : " cursor-pointer ") +
        className
      }
      {...props}
    >
      <div className="p-3 align-items-center justify-content-center border-round-3xl">{itemIcon}</div>
      <HUText fontStyle="LM" className="p-2 ml-2" color={theme.mainWhite}>
        {item.title}
      </HUText>
      {item.sharedCoachStatus === SharedCoachStatus.PENDING && (
        <GradientOverlay>
          <ClockOutlineIcon color={theme.mainWhite} width={24} height={24} />
          <HUText fontStyle="TS" color={theme.mainWhite} className="text-center">
            {word("program.sharedCoach.status.pendingValidation")}
          </HUText>
        </GradientOverlay>
      )}
    </div>
  )
}

const GradientOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-width: 0px;
  height: 100%;
  width: 100%;
  z-index: 1;
  background: linear-gradient(180deg, rgba(34, 34, 34, 0.62) 70%, #222 99.9%);
  backdrop-filter: blur(1px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
  gap: 0.4rem;
`
